import { ThemeService } from './../shared/theme-service/theme.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';

@Component({
	selector: 'app-dinamic-css',
	templateUrl: './dinamic-css.component.html',
	styleUrls: ['./dinamic-css.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DinamicCssComponent implements OnInit {
	primaryColor: any;
	cssVariables: any;
	themeConfs: any;
	constructor(private themeService: ThemeService) {
		/* call the service/api to get the css variable values in cssVariables */
		// if (this.themeService) {
		// 	this.themeConfs = this.themeService.getThemeConfigs();
		// 	console.log('not empty', this.themeConfs);
		// 	this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		// }
	}




	ngOnInit() {

		// this.appendCss(this.themeService.themeConfigs);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/dinamic-css/dinamic-css.component.ts